import QuizListAdmin from "../../components/quiz/QuizListAdmin";

export default function QuizListAdminPage(){
     return(
          <div>
               <QuizListAdmin />
          </div>
     )
}